import { SplashPage } from '@core/ui';

export const SPLASH_PAGE = <SplashPage />;
